<template>
    <button
        :type="buttonType"
        :disabled="isDisabled || isLoading"
        :class="[ appliedVariant, radiuses[radius], sizes[size] ]"
        class="relative flex justify-center items-center font-freizeit transition-all duration-300 ease-in"
    >
        <transition name="fade">
            <span
                v-if="!isLoading"
                class="absolute w-full h-full flex justify-center items-center"
            >
                <slot />
            </span>

            <div
                v-else
                class="loading-ellipsis relative inline-block w-20 h-3.5"
            >
                <div class="absolute left-2 rounded-full w-3 h-3 bg-cloud" />
                <div class="absolute left-2 rounded-full w-3 h-3 bg-cloud" />
                <div class="absolute left-8 rounded-full w-3 h-3 bg-cloud" />
                <div class="absolute left-14 rounded-full w-3 h-3 bg-cloud" />
            </div>
        </transition>
    </button>
</template>

<style scoped>
.loading-ellipsis div {
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.loading-ellipsis div:nth-child(1) {
    animation: loading-ellipsis-1 0.7s infinite;
}
.loading-ellipsis div:nth-child(2) {
    animation: loading-ellipsis-2 0.7s infinite;
}
.loading-ellipsis div:nth-child(3) {
    animation: loading-ellipsis-2 0.7s infinite;
}
.loading-ellipsis div:nth-child(4) {
    animation: loading-ellipsis-3 0.7s infinite;
}

@keyframes loading-ellipsis-1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes loading-ellipsis-2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}
@keyframes loading-ellipsis-3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
</style>

<script>
    export default {
        props: {
            buttonType: {
                type: String,
                default: 'button',
            },
            variant: {
                type: String,
                default: 'primary',
            },
            radius: {
                type: String,
                default: '',
            },
            size: {
                type: String,
                default: 'medium',
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                variants: {
                    primary: 'rounded-xl bg-black text-cloud',
                    secondary: 'rounded-xl border border-black text-black',
                    shine: 'bg-shine text-black text-2xl',
                },
                radiuses: {
                    rounded: 'rounded-full',
                },
                sizes: {
                    small: 'h-7 text-xs',
                    medium: 'h-10',
                    large: 'h-14',
                },
            };
        },

        computed: {
            appliedVariant() {
                return this.variant === 'primary' && this.isDisabled === true ? this.variants.secondary : this.variants[this.variant];
            },
        },
    };
</script>
